import { Box, Stack, Typography } from '@mui/material'
import { formatDateDMY } from '@/utils/date'
import type { WidgetProps } from './WidgetProps'
import { EmptyHint } from './EmptyHint'

interface NewsRow {
  id: number
  title: string
  preview: string | null
  created_at: string | null
}

export function NewsWidget({ payload }: WidgetProps) {
  const items = (payload.items ?? []) as NewsRow[]

  if (items.length === 0) {
    return <EmptyHint fallbackKey="dashboard.widgets.news.empty" />
  }

  return (
    <Stack spacing={1.5}>
      {items.map((item) => (
        <Box key={item.id}>
          <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
            <Typography variant="body2" fontWeight={600} sx={{ flexGrow: 1, minWidth: 0 }} noWrap>
              {item.title}
            </Typography>
            <Typography variant="caption" color="text.secondary" sx={{ whiteSpace: 'nowrap' }}>
              {formatDateDMY(item.created_at)}
            </Typography>
          </Box>
          {item.preview && (
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
              }}
            >
              {item.preview}
            </Typography>
          )}
        </Box>
      ))}
    </Stack>
  )
}
